export default __webpack_public_path__ + "static/media/creative-agency.6d868c99.png";